/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilieraUpdateDTO
 */
export interface FilieraUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof FilieraUpdateDTO
     */
    descrizione: string;
    /**
     * 
     * @type {number}
     * @memberof FilieraUpdateDTO
     */
    idAnagrafe?: number;
}

/**
 * Check if a given object implements the FilieraUpdateDTO interface.
 */
export function instanceOfFilieraUpdateDTO(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "descrizione" in value;

    return isInstance;
}

export function FilieraUpdateDTOFromJSON(json: any): FilieraUpdateDTO {
    return FilieraUpdateDTOFromJSONTyped(json, false);
}

export function FilieraUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilieraUpdateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'descrizione': json['descrizione'],
        'idAnagrafe': !exists(json, 'idAnagrafe') ? undefined : json['idAnagrafe'],
    };
}

export function FilieraUpdateDTOToJSON(value?: FilieraUpdateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'descrizione': value.descrizione,
        'idAnagrafe': value.idAnagrafe,
    };
}

